export default "__VITE_ASSET__Dr8Fhv7s__"